import { Box, Card, CardContent, Chip, Typography } from "@mui/joy";
import { LayoutGrid } from "lucide-react";

interface ICategoryNavigation {
    categories: any;
    onClick: (e: string) => any;
}

export function CategoryNavigation(props: ICategoryNavigation) {
    const { categories, onClick } = { ...props };
    return (
        <Box sx={{ backgroundColor: "background.level1", width: "20rem", overflow: "auto" }} p={2}>
            <Typography level="title-sm">Categories</Typography>
            <Box mt={2} display={"flex"} flexDirection={"column"} gap={1}>
                {categories.map((category: any, index: any) => (
                    <CategoryCard
                        key={index}
                        name={category.name}
                        availableItems={category.availableItems}
                        onClick={onClick}
                        subCategories={category.subcategories}
                    />
                ))}
            </Box>
        </Box>
    );
}

function CategoryCard(props: ICategoryCard) {
    const { name, availableItems, onClick, subCategories } = { ...props };
    return (
        <Card onClick={() => onClick(name)} sx={{ cursor: "pointer" }}>
            <CardContent>
                <Box display={"flex"} alignItems={"center"} gap={1} justifyContent={"space-between"}>
                    <Box display={"flex"} alignItems={"center"} gap={1}>
                        <LayoutGrid size={16} />
                        <Typography sx={{ fontWeight: 600 }}>{name}</Typography>
                    </Box>
                    <Chip variant="outlined" size="sm" sx={{ borderRadius: 7 }}>
                        {availableItems}
                    </Chip>
                </Box>

                {/* <Box mt={1.5} ml={3} display="flex" flexWrap="wrap" gap={1}>
          <Typography>
            Sub Categories {subCategories.length}
          </Typography>
        </Box> */}
            </CardContent>
        </Card>
    );
}

interface ICategoryCard {
    name: string;
    availableItems: number;
    onClick: (e: string) => any;
    subCategories: string[];
}
